const classify = require('./lib/classify')

const surveys = {
  nla17: {
    t1: '2012',
    t2: '2017',
    latest_year: '2017',
    'chart_section_title-curr_cond': 'What was the condition in 2017?',
    'chart_title-curr_cond': 'Indicator Condition (2017)',
    'chart_subtitle-curr_cond': 'Percentage of lakes in each condition category nationally',
    'chart_section_title-change': 'Did the condition change?',
    'chart_title-change': 'Change in Indicator Condition (2012 to 2017)',
    'chart_subtitle-change': 'Percentage of lakes in each condition category nationally',
    'chart_subtitle-risk': 'Risk to Response nationally',
    axis_labels: ["'12", "'17"],
    'sig_note-change': ' Indicates statistically significant difference (95% confidence) between 2012 and 2017.',
    data_download_link: `For more details, <a class='downloadLink' title ='Data Download' href = ''>download the data</a>
             for this chart, or visit the NLA dashboards for <a href="../dashboard/?&view=subpopulation&studypop=al&type=wsa9+ecoregions&indicator=INDICATORFORLINK&label=pe&condition=good&diff=2v3" target="_blank"> ecoregional data</a> on INDICATOR.`,
    risk_chart_link:
      "For more details, <a class='downloadLink' title ='Data Download' href = ''>download the chart data</a>" +
      ", or visit the NLA dashboards for <a class = 'dashboardLink' title = 'Dashboard Link' href = '../dashboard/?&view=risk&studypop=al&subpop=SUBPOPULATION&response=RESPONSE&label=pe'>" +
      'additional risk data</a>.',
    peer_review: false,
    currentDownloadTitle: 'NLA2017-Condition-Estimates_Lakes-Greater-Than-1-Hectare_National_Indicator',
    changeDownloadTitle: 'NLA2017-Change-Estimates_Lakes-Greater-Than-1-Hectare_National_Indicator_2012-2017',
    riskDownloadTitle: 'NLA2017_Attributable-Risk-to-Response-Estimates_chartSubpop',
    sigFlagColumn: 'Sig.P.T3-T2.Cond',
  },
  nwca16: {
    t1: '2011',
    t2: '2016',
    latest_year: '2016',
    'chart_section_title-curr_cond': 'What was the condition in 2016?',
    'chart_title-curr_cond': 'Indicator Condition (2016)',
    'chart_subtitle-curr_cond': 'Percentage of wetland area in each condition category nationally',
    'chart_section_title-change': 'Did the condition change?',
    'chart_title-change': 'Change in Indicator Condition (2011 to 2016)',
    'chart_subtitle-change': 'Percentage of wetland area in each condition category nationally',
    'chart_subtitle-risk': 'In relation to: RESPONSE',
    axis_labels: ["'11", "'16"],
    'sig_note-change': ' Indicates statistically significant difference (95% confidence) between 2011 and 2016.',
    data_download_link: `For more details, <a class='downloadLink' title ='Data Download' href = ''>download the data</a>
             for this chart, or visit the NWCA dashboards for <a href="../dashboard/?&view=condEst&subview=subpopulation&type=agg.+ecoregions+(all+wetlands)&indicator=INDICATORFORLINK&label=none&condition=good&scale=percent" target="_blank"> ecoregional data</a> on INDICATOR.`,
    risk_chart_link:
      "For more details, <a class='downloadLink' title ='Data Download' href = ''>download the chart data</a>" +
      ", or visit the NWCA dashboards for <a class = 'dashboardLink' title = 'Dashboard Link' href = ../dashboard/?&view=risk&subpop=SUBPOPULATION&response=RESPONSE&label=none&scale=percent> " +
      'additional risk data</a>.',
    peer_review: false,
    currentDownloadTitle: 'NWCA2016-Condition-Estimates_National-All-Wetlands_Indicator',
    changeDownloadTitle: 'NWCA2016-Change-Estimates_National-All-Wetlands_Indicator_2011-2016',
    riskDownloadTitle: 'NWCA2016_Attributable-Risk-to-Response-Estimates_National',
    sigFlagColumn: 'Sig.P.T2-T1.Cond',
  },
  nrsa1819: {
    t1: '2008-09',
    t2: '2013-14',
    t3: '2018-19',
    latest_year: '2018-19',
    'chart_section_title-curr_cond': 'What was the condition in 2018-19?',
    'chart_title-curr_cond': 'Indicator Condition (2018-19)',
    'chart_subtitle-curr_cond': 'Percentage of river and stream miles in each condition category nationally',
    'chart_section_title-change': 'Did the condition change?',
    'chart_title-change': 'Change in Indicator Condition (2008-09 to 2018-19)',
    'chart_subtitle-change': 'Percentage of river and stream miles in each condition category nationally',
    'chart_subtitle-risk': 'Risk to RESPONSE nationally',
    axis_labels: ['08-09', '13-14', '18-19'],
    'sig_note-change': ' Indicates statistically significant difference (95% confidence) between 2013-14 and 2018-19.',
    data_download_link: `For more details, <a class='downloadLink' title ='Data Download' href = ''>download the data</a>
             for this chart, or visit the NRSA dashboards for <a href="../dashboard/?&view=subpopulation&studypop=rs&type=wsa9+ecoregions&indicator=INDICATORFORLINK&label=none&condition=good&diff=2v3" target="_blank"> ecoregional data</a> on INDICATOR.`,
    risk_chart_link:
      "For more details, <a class='downloadLink' title ='Data Download' href = ''>download the chart data</a>" +
      ", or visit the NRSA dashboards for <a class = 'dashboardLink' title = 'Dashboard Link' href = ../dashboard/?&view=risk&studypop=rs&subpop=national&response=benthic+macroinvertebrates&label=none> " +
      'additional risk data</a>.',
    peer_review: false,
    currentDownloadTitle: 'NRSA1819-Condition-Estimates_National_Indicator',
    changeDownloadTitle: 'NRSA1819-Change-Estimates_National_Indicator_2008_09-2018_19',
    riskDownloadTitle: 'NRSA1819_Attributable-Risk-to-Response-Estimates_National',
    sigFlagColumn: 'Sig.P.T3-T2.Cond',
  },
}



    let curr_survey = String(document.getElementById('condData').getAttribute('survey'));
    curr_survey_data = surveys[curr_survey];
    
    /// update cond chart area label
    document.querySelectorAll('.chart_section_title').forEach(element => {
        element.innerHTML = curr_survey_data['chart_section_title-curr_cond'];
    });
    
    //update cond chart titles
    document.querySelectorAll('.cond-chart-header').forEach(element => {
        var indicator = element.closest('.chartDiv').getAttribute('indicator');
        if (indicator.includes('Chlorophyll')) {
            indicator = "Chlorophyll <span class='italic'>a</span>";
        }
        element.innerHTML = curr_survey_data['chart_title-curr_cond'].replace("Indicator", indicator);
    })
    
    //update cond chart subtitles
    document.querySelectorAll('.cond-chart-subtitle').forEach(element => {
        element.innerHTML = curr_survey_data['chart_subtitle-curr_cond'];
    });
    
    // let arr = [];
    
    //update cond chart data download link
    document.querySelectorAll('.cond-chart-link').forEach(element => {
        var indicator = element.closest('.chartDiv').getAttribute('indicator');
        // console.log("indicator: ", indicator);
        indicator_for_text = indicator.includes('Chlorophyll') ? "chlorophyll <span class='italic'>a</span>" : indicator.toLowerCase();
        if(indicator === "Physical Alterations (Sum)") {
            element.innerHTML = curr_survey_data['data_download_link']
                .replaceAll("INDICATORFORLINK","physical+alterations+(sum)")
                .replaceAll("INDICATOR", indicator_for_text);
        } else if (indicator === "Water Addition/Subtraction") {
            element.innerHTML = curr_survey_data['data_download_link']
                .replaceAll("INDICATORFORLINK", "water+addition/subtraction")
                .replaceAll("INDICATOR", indicator_for_text);
        } else if (indicator === "In-Stream Fish Habitat") {
            element.innerHTML = curr_survey_data['data_download_link']
                .replaceAll("INDICATORFORLINK", "in-stream+fish+habitat")
                .replaceAll("INDICATOR", indicator_for_text);
        } else if (indicator === "Vegetation MMI"){
            element.innerHTML = curr_survey_data['data_download_link']
            .replaceAll("INDICATORFORLINK", classify(indicator).replaceAll('-', '+'))
            .replaceAll("INDICATOR", "vegetation MMI");
        }else {
            element.innerHTML = curr_survey_data['data_download_link']
                .replaceAll("INDICATORFORLINK", classify(indicator).replaceAll('-', '+'))
                .replaceAll("INDICATOR", indicator_for_text);
        }
            // arr.push(element.previousElementSibling.previousElementSibling.previousElementSibling.innerText);
    });
    
    // console.log(arr);
    
    /// update change chart area label
    document.querySelectorAll('.change_section_title').forEach(element => {
        element.innerHTML = curr_survey_data['chart_section_title-change'];
    });
    
    //update change chart titles
    document.querySelectorAll('.change-chart-header').forEach(element => {
        var indicator = element.closest('.chartDiv').getAttribute('indicator');
        if (indicator.includes('Chlorophyll')) {
            indicator = "Chlorophyll <span class='italic'>a</span>";
        }
        element.innerHTML = curr_survey_data['chart_title-change']
        .replace("Indicator", indicator);
    })
    
    //update change chart subtitles
    document.querySelectorAll('.change-chart-subtitle').forEach(element => {
        element.innerHTML = curr_survey_data['chart_subtitle-change'];
    })
    
    //update change chart data download link
    document.querySelectorAll('.change-chart-link').forEach(element => {
        var indicator = element.closest('.chartDiv').getAttribute('indicator');
        indicator_for_text = indicator.includes('Chlorophyll') ? "chlorophyll <span class='italic'>a</span>" : indicator.toLowerCase();
        if(indicator === "Physical Alterations (Sum)") {
            element.innerHTML = curr_survey_data['data_download_link']
                .replaceAll("INDICATORFORLINK","physical+alterations+(sum)")
                .replaceAll("INDICATOR", indicator_for_text);
        } else if (indicator === "Water Addition/Subtraction") {
            element.innerHTML = curr_survey_data['data_download_link']
                .replaceAll("INDICATORFORLINK", "water+addition/subtraction")
                .replaceAll("INDICATOR", indicator_for_text);
        } else if (indicator === "In-Stream Fish Habitat") {
            element.innerHTML = curr_survey_data['data_download_link']
                .replaceAll("INDICATORFORLINK", "in-stream+fish+habitat")
                .replaceAll("INDICATOR", indicator_for_text);
        } else if (indicator === "Vegetation MMI"){
            element.innerHTML = curr_survey_data['data_download_link']
            .replaceAll("INDICATORFORLINK", classify(indicator).replaceAll('-', '+'))
            .replaceAll("INDICATOR", "vegetation MMI");
        } else {
            element.innerHTML = curr_survey_data['data_download_link']
                .replaceAll("INDICATORFORLINK", classify(indicator).replaceAll('-', '+'))
                .replaceAll("INDICATOR", indicator_for_text);
        }
    });

    //update risk dashboard links
    document.querySelectorAll('.chart_link_risk').forEach(element =>{
        let subpop = element.closest('.chartDiv').getAttribute('subpop');
        let response = element.closest('.chartDiv').getAttribute('response');
        element.innerHTML = curr_survey_data.risk_chart_link
        .replaceAll("SUBPOPULATION", subpop.replaceAll(' ', "+").replaceAll("-", "+").replaceAll("_", "+"))
        .replaceAll("RESPONSE", response.replaceAll(' ', "+").replaceAll("-", "+"));
    });
    
    ///risk chart titles are set in the text document because there are so few of them and, gramatically
    // it can be hard to fit in the subpopulation text appropriately
    
    //update risk chart subtitles
    document.querySelectorAll('.risk-chart-subtitle').forEach(element => {
        let response = element.closest('.chartDiv').getAttribute('response').replaceAll("_", " ");
        if(response === "vegetation mmi") {
            element.innerHTML = curr_survey_data['chart_subtitle-risk'].replaceAll("RESPONSE", "Vegetation MMI");
        } else if (response === "nonnative plants") {
            element.innerHTML = curr_survey_data['chart_subtitle-risk'].replaceAll("RESPONSE", "Nonnative Plants");
        } else {
            element.innerHTML = curr_survey_data['chart_subtitle-risk']
            .replaceAll("RESPONSE", response);
        }
    });
    
    // the peer review elements-- line numbers and footer- are survey dependent in that some surveys need them 
    // but others don't. The line numbers are pseudo elements (::before), making them more complicated to 
    // access. This code reaches into the css stylesheet itself and deletes the properties. See this thread:
    /// https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration/setProperty
    // This is an interesting approach by accessing the stylesheet itself. Consider modifying the HTML to allow for us to select the necessary elements instead.
    const styleSheetList = document.styleSheets;
    let found = Object.keys(styleSheetList)
    .filter(cssStyleSheet => styleSheetList[cssStyleSheet].href?.includes("/style.css"))
    .map(cssStyleSheet => styleSheetList[cssStyleSheet]);
    const stylesheet = found[0].cssRules;

    if (curr_survey_data['peer_review'] == false) {
        
        for (let i = 0; i < stylesheet.length; i++) {
            if (typeof stylesheet[i]['selectorText'] === "string" && 
                    stylesheet[i]['selectorText'].includes("before") && 
                    !stylesheet[i].selectorText.includes('exhibit') && 
                    !stylesheet[i].selectorText.includes('caption')) {
                stylesheet[i].style.removeProperty('counter-increment');
                stylesheet[i].style.removeProperty('content');
            }
            //this removes the left padding on mobile. To see what's going on console.log stylesheet[i] & stylesheet[i+1]
            if (typeof (stylesheet[i].selectorText) == 'string' &&
            stylesheet[i].selectorText == '.main') {
                stylesheet[i + 1].cssRules[0].style['padding-left'] = '1rem';
            }
        }
        document.querySelectorAll('.main p').forEach(element => {
            element.style['text-indent'] = 0;
        });
        document.querySelector('.main').style['margin-left'] = 0;
        // Change to "display: none" to hide peer review banner
        document.querySelector('#watermark').style.display = 'none';
    } else if (curr_survey_data['peer_review'] == true) {
        document.querySelector('#watermark').style.display = 'block';
        for (let i = 0; i < stylesheet.length; i++) {
            if (typeof (stylesheet[i].selectorText) == 'string' &&
            stylesheet[i].selectorText.includes('::before') &&
            !stylesheet[i].selectorText.includes('exhibit') &&
            !stylesheet[i].selectorText.includes('caption')) {
                stylesheet[i].style.display = 'inline';
            }

        }
    }
    
    
    module.exports = {
        curr_survey: curr_survey,
        survey_dict: surveys
    }